module.exports = __webpack_public_path__ + "img/function-icon1.f56ab5d9.png";